import React from 'react'
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import About from './pages/About';
import Contact from './pages/Contact';
import TermsAndCondition from './pages/TermsAndCondition';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ResearchArticles from './pages/ResearchArticles';
import RefundAndCancellationPolicy from './pages/RefundAndCancellationPolicy';
import AgricultureService from './pages/AgricultureService';
import WaterService from './pages/WaterService';
import ClimateRiskService from './pages/ClimateRiskService';


const App = () => {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/about" element={<About />}/>
        <Route path="/contact" element={<Contact />}/>
        <Route path="/terms-and-condition" element={<TermsAndCondition />}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
        <Route path="/research-articles" element={<ResearchArticles />}/>
        <Route path="/refund-and-cancellation-policy" element={<RefundAndCancellationPolicy />}/>
        <Route path="/service/agriculture" element={<AgricultureService />}/>
        <Route path="/service/water" element={<WaterService />}/>
        <Route path="/service/climate-risk" element={<ClimateRiskService />}/>
      </Routes>
      <ScrollToTop/>
      <Footer/>
    </Router>
  )
}

export default App